// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
//import axios from 'axios';
import { getAuthToken, getAuthType } from '../../utils/auth';

 // Async Thunks
export const loginUser = createAsyncThunk('auth/UserLogin', async (credentials: {customer:  {email: string; password: string }}) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer_login',{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json', 
        },
        body: JSON.stringify(credentials),
    });  
    return response.json(); 
});

export const adminLoginUser = createAsyncThunk('auth/AdminLogin', async (credentials: {admin:  {email: string; password: string }},{rejectWithValue}) => {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/admin_login',{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', 
            },
            body: JSON.stringify(credentials),
        });  
        return response.json();  
});

export const logoutUser = createAsyncThunk('auth/UserLogout', async (_, { rejectWithValue }) => {
     const token = getAuthToken();
    try {
      const response =  await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer_logout',{
        method: 'delete',
        headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer ${token}`},
        }); 
        return response.json(); 
 

    } catch (error:any) {
      return rejectWithValue(error.response.data );
    }
});

export const logoutAdmin = createAsyncThunk('auth/AdminLogout', async (_, { rejectWithValue }) => {
    const token = getAuthToken();
   try {
     const response =  await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/admin_logout',{
       method: 'delete',
       headers: {
           'Content-Type':'application/json',
           'Authorization': `Bearer ${token}`},
       }); 
       return response.json(); 


   } catch (error:any) {
     return rejectWithValue(error.response.data );
   }
});

export const registerUser = createAsyncThunk('auth/UserRegister', async (credentials: {}) => {
    const formData = new FormData();
    formData.append("customer[first_name]", credentials['customer']['firstName']); 
    formData.append("customer[last_name]", credentials['customer']['lastName']); 
    formData.append("customer[mobile]", credentials['customer']['mobile']); 
    formData.append("customer[email]", credentials['customer']['email']); 
    formData.append("customer[password]", credentials['customer']['password']); 
    formData.append("customer[password_confirmation]", credentials['customer']['passwordConfirmation']); 

    const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/customer_register',{
        method: 'POST',
        headers: {
          //  'Content-Type': 'application/json', 
        },
        body: formData,
    });  
    return response.json(); 
});

export const getLoginDetails = createAsyncThunk('auth/getLoginDetails', async () => {
    const token = getAuthToken();
    const authType = getAuthType();
    let path;
    if(authType === "User") {
        path =  '/api/v1/customer/profiles/loggedin_customer'
    }
    else if(authType === "Admin") {
        path =  '/api/v1/admin/profiles/loggedin_admin'  
    }
    const response = await fetch(process.env.REACT_APP_SERVER_URL + path,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${token}`,
        } 
    });  
    return response.json(); 
    
});
 
export const addToWishList = createAsyncThunk('products/addToWishList', async (product_id:string) => {
    const token = getAuthToken();
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/products/'+product_id+'/add_to_wishlist',{
         headers: {
             'Content-Type':'application/json',
             'Authorization': `Bearer ${token}`,
           }, 
           method: 'GET',
 
     }); 
     return response.json(); 
});
  
export const removeFromWishList = createAsyncThunk('products/removeFromWishList', async (product_id:string) => {
    const token = getAuthToken();
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/products/'+product_id+'/remove_from_wishlist',{
         headers: {
             'Content-Type':'application/json',
             'Authorization': `Bearer ${token}`,
           }, 
           method: 'GET',
 
     }); 
     return response.json(); 
});

export const fetchWishlistProducts = createAsyncThunk('products/fetchWishlistProducts', async () => {
    const token = getAuthToken();
     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/products/wishlist',{
         headers: {
             'Content-Type':'application/json',
             'Authorization': `Bearer ${token}`,
           }, 
           method: 'GET',
     }); 
     return response.json(); 
});

// export const updateProfile = createAsyncThunk('auth/updateProfile', async (editProfile: {}) => {
//     const token = getAuthToken();
//     //console.log("33333333333333",editProfile)
//     const formData = new FormData();
//     formData.append("profile[name]", editProfile["name"]);  

//      const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/v1/user/profiles/'+ editProfile['id'],{
//          headers: {
//              //'Content-Type':'application/json',
//              'Authorization': `Bearer ${token}`,
//               //  'Content-Type': 'multipart/form-data'
//            }, 
//            method: 'PUT',
//            body: formData
 
//      }); 
//      return response.json(); 
//  });
 
// Slice
const authSlice = createSlice({
    name: 'auth',
    initialState: {
        loggedInUser: null,
        loading: false,
        formErrors: [],
        wishlist_ids: [],
        error: '',
        authToken: '',
        wl_products:   ([] as any[]),
        loginModalShow: false,
        loginUserType: ''
    },
    reducers: {
        logout: (state) => {
            state.loggedInUser = null;
        },
        loginModalOpen: (state, action) => {
            state.loginModalShow = true;
            state.loginUserType = action.payload;
        },
        loginModalClose: (state) => {
            state.loginModalShow = false;
            state.loginUserType = '';
        },
        errorEmpty: (state) => {
            state.error = ''
        }
        // loginModalType: (state, action) => {
        //     state.loginModalValue = action.payload;
        // }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(loginUser.fulfilled, (state, action) => {
               // console.log("eeeeeee auth login",action.payload['status']['data']['user'],action.payload['status']['data']['user']['token'])
                //console.log("action paylod loggedin",action.payload)
                if (action.payload.status === 'success'){
                    const token = action.payload['data']['customer']['token']
                    state.loading = false;
                    state.loggedInUser = action.payload['data']['customer'];
                    state.wishlist_ids = action.payload['data']['wishlist_ids']
                    state.error = '';
                    sessionStorage.setItem('authToken',  token);
                    sessionStorage.setItem('authType',  "User");
                    state.authToken = token
                }
                else{
                    state.loading = false;
                    state.error = 'Invalid Email or Password'; 
                }
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = 'Invalid Email or Password';
            })

            .addCase(adminLoginUser.pending, (state) => {
                state.loading = true;
                state.error = '';
               // state.loginModalShow = false;
            })
            .addCase(adminLoginUser.fulfilled, (state, action) => {
               // console.log("eeeeeee auth login",action.payload['status']['data']['user'],action.payload['status']['data']['user']['token'])
                //console.log("action paylod loggedin",action.payload)
                if (action.payload.status === 'success'){
                    const token = action.payload['data']['admin']['token']
                    state.loading = false;
                    state.loggedInUser = action.payload['data']['admin'];
                    state.error = '';
                    sessionStorage.setItem('authToken',  token);
                    sessionStorage.setItem('authType',  "Admin");
                    state.authToken = token
                }
                else{
                    state.loading = false;
                    state.error = 'Invalid Email or Password'; 
                }
            })
            .addCase(adminLoginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = 'Invalid Email or Password';
            })

            .addCase(logoutUser.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(logoutUser.fulfilled, (state, action) => {
                const res = action.payload['status'];
                state.loading = false;
                state.loggedInUser = null;
                state.error = '';
                state.authToken = '';
                state.formErrors = [];
                state.wishlist_ids = [];
                state.wl_products =  [];
                if ((res["code"] === 200) && (res["message"] === "Logged out successfully.")){
                    
                }
                if ((res["code"] === 401) && (res["message"] === "Couldn't find an active session.")){
                        
                }
                sessionStorage.removeItem('authToken'); // Remove token from session storage


            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message+'';
            })
            .addCase(getLoginDetails.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(getLoginDetails.fulfilled, (state, action) => {
               // console.log("eeeeeee auth login",action.payload['status']['data']['user'],action.payload['status']['data']['user']['token'])
                if (action.payload.status === 'success'){
                    state.loading = false;
                    state.loggedInUser = action.payload['data']['customer'];
                    state.wishlist_ids = action.payload['data']['wishlist_ids']
                    state.error = ''; 
                }
                else{
                    state.loading = false;
                    state.error = '' + action.payload['errors']; 
                }
            })
            .addCase(getLoginDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = 'Invalid Email or Password';
            })
            .addCase(addToWishList.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(addToWishList.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.wishlist_ids = action.payload['data']['wishlist_ids']
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(addToWishList.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })
            
            .addCase(removeFromWishList.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(removeFromWishList.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    state.wishlist_ids = action.payload['data']['wishlist_ids']
                    state.wl_products = state.wl_products.filter(product => product.id+'' !== action.payload.removed_id+'');
                }
                else{
                    state.loading = false;
                    state.error = ''; 
                }
            })
            .addCase(removeFromWishList.rejected, (state, action) => {
                state.loading = false;
                state.error = '';
            })
                        
            .addCase(fetchWishlistProducts.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWishlistProducts.fulfilled, (state, action) => {
                state.loading = false;
                state.wl_products = action.payload.data;
                //state.wishlist_ids = action.payload['data']['wishlist_ids']

                state.error = '';
            })
            .addCase(fetchWishlistProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message + "";

            })
             
            .addCase(registerUser.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(registerUser.fulfilled, (state, action) => {
                if (action.payload.status === 'success'){
                    const token = action.payload['data']['customer']['token']
                    state.loading = false;
                    state.loggedInUser = action.payload['data']['customer'];
                    state.wishlist_ids = action.payload['data']['wishlist_ids']
                    state.error = '';
                    sessionStorage.setItem('authToken',  token);
                    state.authToken = token
                }
                else{
                    state.loading = false;
                    state.formErrors = action.payload.errors; 
                }
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.loading = false;
                state.error = 'error';
            })

            .addCase(logoutAdmin.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(logoutAdmin.fulfilled, (state, action) => {
                const res = action.payload['status'];
                state.loading = false;
                state.loggedInUser = null;
                state.error = '';
                state.authToken = '';
                state.formErrors = []; 
                if ((res["code"] === 200) && (res["message"] === "Logged out successfully.")){
                    
                }
                if ((res["code"] === 401) && (res["message"] === "Couldn't find an active session.")){
                        
                }
                sessionStorage.removeItem('authToken'); // Remove token from session storage


            })
            .addCase(logoutAdmin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message+'';
            })

            // .addCase(updateProfile.pending, (state) => {
            //     state.loading = true;
            // })
            // .addCase(updateProfile.fulfilled, (state, action) => {
            //     if(action.payload.status === 'success'){
            //         state.loggedInUser = action.payload['data']['customer'];
            //         state.formErrors=[]; 
            //    }
            //     else{
            //         state.formErrors = action.payload.errors ;
            //     }
            // })
            // .addCase(updateProfile.rejected, (state, action) => {
            //     state.loading = false; 
            //     state.error = action.error.message + "";

            // })

            
    }
});

//export const { logout } = authSlice.actions;
export const { loginModalClose,loginModalOpen,errorEmpty } = authSlice.actions;

export default authSlice.reducer;
